import React from "react";

const ArrowMore = () => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="arrow-more"
    >
      <rect
        width="9.64226"
        height="1.79841"
        rx="0.899207"
        transform="matrix(0.714868 -0.69926 0.714868 0.69926 5.82031 6.74219)"
        fill="#FFFFFF"
      />
      <rect
        width="9.64226"
        height="1.79841"
        rx="0.899207"
        transform="matrix(0.714868 0.69926 -0.714868 0.69926 1.28516 0)"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export default ArrowMore;
